import React from 'react';
import { Icon } from '@chakra-ui/react';
import { BsCircleFill } from 'react-icons/bs';

export const BadgeIcon = ({ color }: { color: string }) => {
  return <Icon as={BsCircleFill} color={color} h="3" w="3" />;
};
